import TemplateStore from '../templates/template-store';
import containingActiveOrientation from '../edit-area/containing-active-orientation.js';
import prismItemInterrogator from '../misc/prism-item-interrogator';
import { usePrismItemStore } from 'stores/usePrismItemStore';
import templateInterrogator from '../misc/template-interrogator';
import { hasEdgesTray, isAlbum } from '../trays/tray-determiner';

// I have barely little idea what the hell is going on here and it looks like
// Taha didn't fare any better either, according to his comments.

// Looking for function getTemplateOrientation(tags)? This has moved to template-inetrrogator.js
// ------------------------------------------------------------------------------------------

// Returns current active section
function getCurrentSection() {
  return prismItemInterrogator.getCurrentSection();
}

// ------------------------------------------------------------------------------------------

function getFoldersBySection(templates, edges) {
  // returns designs (aka folders) for specific section
  const wrap = TemplateStore.currentWrap();
  const activeSection = getCurrentSection();
  const folders = [];

  for (const template of templates) {
    if (template.suitable_for.indexOf(activeSection) === -1) continue;

    // Slim down for canvas wraps
    if (edges && wrap && wrap.group) {
      if (wrap.group.group !== template.group) {
        continue;
      }
    }

    folders.push(template);
  }

  return folders;
}

// ------------------------------------------------------------------------------------------

// returns if current theme is for card theme
function isCard(foldersBySection) {
  const [firstFolder] = foldersBySection || [];

  if (firstFolder && firstFolder.templates.length > 0) {
    return firstFolder.templates[0].tags.indexOf('card') !== -1;
  }

  return false;
}

// ------------------------------------------------------------------------------------------

function filterTemplates(templates, filter, section) {
  templates = templates.filter(
    (template) =>
      (filter === '*' || filter === template['no-photos']) &&
      template.sections.includes(section),
  );

  if (section !== 0) {
    templates = templates.filter((template) =>
      containingActiveOrientation(template),
    );
  }

  return templates.sort((a, b) => (a.name > b.name ? 1 : -1));
}

function getCurrentTemplateSlots() {
  if (!window.activeView || !activeView.template || !activeView.template.pso) {
    return 1;
  }

  return activeView.template.pso.filter((id) => !id.match(/^optional-|:/))
    .length;
}

// ------------------------------------------------------------------------------------------
function getCurrentTemplateOrientation() {
  if (!window?.activeView?.template) return null;
  return TemplateStore.getOrientation(activeView.template.size);
}

// ------------------------------------------------------------------------------------------

function numberOfPhotosInTemplateText(number) {
  switch (number) {
    case 0:
      return 'Text only';
    case 1:
      return '1 photo';
    default:
      return `${number} photos`;
  }
}

// ------------------------------------------------------------------------------------------
function numberOfTextSlotsInTemplateText(number) {
  switch (number) {
    case 0:
      return;
    case 1:
      return '1 text';
    default:
      return `${number} texts`;
  }
}

// ------------------------------------------------------------------------------------------

function getTemplateGroups() {
  try {
    const templateGroups = TemplateStore.list() || [];
    const prismItem = usePrismItemStore.getState().prismItem;
    const layoutFilter = {
      left: 'right',
      right: 'left',
    };

    if (isCard())
      return templateInterrogator.filterTemplatesForThoseWithMultipleOrientations(
        templateGroups,
      );
    if (isAlbum() && prismItem.pages?.[activeView.pageIndex]?.['page-is']) {
      const oppositeSide =
        layoutFilter[prismItem.pages[activeView.pageIndex]['page-is']];

      return templateInterrogator.filterTemplates(templateGroups, {
        side: oppositeSide,
      });
    }

    return templateGroups;
  } catch (error) {
    console.error(error);
    return [];
  }
}

function acquireTemplates() {
  const activeSection = getCurrentSection(),
    templates = [];

  const foldersBySection = getFoldersBySection(
    getTemplateGroups(),
    hasEdgesTray(),
  );

  foldersBySection.forEach((folder) => {
    for (let template of filterTemplates(
      folder.templates,
      '*',
      activeSection,
    )) {
      templates.push(template);
    }
  });

  return templates;
}

// Like acquireTemplates but skips the orientation filter — returns templates for
// all orientations in the current section. Used by orientation-buttons to find
// templates in the *target* orientation before the canvas has switched.
function acquireTemplatesAllOrientations() {
  const activeSection = getCurrentSection();
  const templates = [];

  const foldersBySection = getFoldersBySection(
    getTemplateGroups(),
    hasEdgesTray(),
  );

  foldersBySection.forEach((folder) => {
    folder.templates
      .filter((t) => t.sections.includes(activeSection))
      .forEach((t) => templates.push(t));
  });

  return templates;
}

export {
  acquireTemplates,
  acquireTemplatesAllOrientations,
  getCurrentSection,
  getFoldersBySection,
  getTemplateGroups,
  isCard,
  filterTemplates,
  getCurrentTemplateSlots,
  getCurrentTemplateOrientation,
  numberOfPhotosInTemplateText,
  numberOfTextSlotsInTemplateText,
};
